import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { getCommodityValues } from '../../api/images';

const SubCommodityAutocomplete = ({ 
  value, 
  onChange, 
  commodity = null, 
  multiple = false,
  disabled = false, 
  label = "Sub-commodity", 
  placeholder = "Type to search...", 
  helperText, 
  error, 
  size = "small", 
  fullWidth = true 
}) => {
  const [subCommodityOptions, setSubCommodityOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchSubCommodities = async () => {
      setLoading(true);
      try {
        const values = await getCommodityValues();
        setSubCommodityOptions(values.sub_commodities || []);
      } catch (error) {
        console.error('Failed to fetch sub-commodity values:', error);
        setSubCommodityOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSubCommodities();
  }, [commodity]);

  // Filter sub-commodities based on selected commodity if needed
  // For now, show all sub-commodities
  const filteredOptions = subCommodityOptions;

  if (multiple) {
    return (
      <Autocomplete
        multiple
        value={value || []}
        onChange={(event, newValue) => onChange(newValue)}
        options={filteredOptions}
        loading={loading}
        disabled={disabled || loading}
        fullWidth={fullWidth}
        size={size}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            helperText={helperText}
            error={error}
            variant="outlined"
          />
        )}
      />
    );
  }

  return (
    <Autocomplete
      value={value || null}
      onChange={(event, newValue) => onChange(newValue)}
      options={filteredOptions}
      loading={loading}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      size={size}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          helperText={helperText}
          error={error}
          variant="outlined"
        />
      )}
    />
  );
};

export default SubCommodityAutocomplete;